import * as React from "react";

export const IconDelete = (props: React.SVGProps<SVGSVGElement>): React.JSX.Element => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M5.83301 17.5C5.37467 17.5 4.98231 17.3368 4.65592 17.0104C4.32954 16.684 4.16634 16.2917 4.16634 15.8333L4.16634 5H3.33301L3.33301 3.33333L7.49967 3.33333V2.5L12.4997 2.5V3.33333L16.6663 3.33333V5H15.833L15.833 15.8333C15.833 16.2917 15.6698 16.684 15.3434 17.0104C15.017 17.3368 14.6247 17.5 14.1663 17.5H5.83301ZM7.49967 14.1667L9.16634 14.1667L9.16634 6.66667H7.49967L7.49967 14.1667ZM10.833 14.1667H12.4997L12.4997 6.66667L10.833 6.66667L10.833 14.1667Z"
      fill="#E57373"
    />
  </svg>
);
